import { IStore } from "../types/IStore";

export const getRecurrence = (state: IStore) => state.recurrence.recurrence;
